import { Pipe, PipeTransform } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { getMoment } from '../services/datetime.service';

@Pipe({
  name: 'withoutTimePresentation'
})
export class WithoutTimePresentationPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (value === '0001-01-01T00:00:00+00:00' || value === '1900-01-01T00:00:00+00:00' || !value) {
      return '--:--';
    } else {
      const format = `${environment.dateFormatSystem} ${environment.timeFormat}`;
      const message = getMoment(value, format).format('HH:mm');
      return message;
    }
  }

}
